export default {
	namespaced: true,
	state: {
		list: [],
		accountants: [],
		permissions: [],
	},

	mutations:{
		/**
		 * [setPermissions description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setPermissions(state, payload) {
			state.permissions=payload
		},

		/**
		 * [deleteAccountant description]
		 * @param  {[type]} state      [description]
		 * @param  {[type]} account_id [description]
		 * @return {[type]}            [description]
		 */
		deleteAccountant(state, account_id) {
			for (let i = 0; i < state.accountants.length; i++) {
				if(state.accountants[i].id==account_id) {
					state.accountants.splice(i, 1);
					break
				}
			}
		},

		/**
		 * [updateAccountant description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		updateAccountant(state, payload) {
			for (let i = 0; i < state.accountants.length; i++) {
				if(state.accountants[i].id==payload.id) {
					state.accountants[i]=payload
					break
				}
			}
		},

		/**
		 * [addAccountant description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addAccountant(state, payload) {
			state.accountants.push(payload)
		},

		/**
		 * [setAccountants description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setAccountants(state, payload) {
			state.accountants=payload
		},

		/**
		 * [setList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setList(state, payload){
			state.list=payload
		},


		/**
		 * [addList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addList(state, payload){
			state.list.push(payload)
		},
	},
	getters:{
		/**
		 * [permissions description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		permissions(state) {
			return state.permissions
		},

		/**
		 * [accountants description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		accountants(state, payload) {
			return state.accountants
		},

		/**
		 * [getList description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		getList(state) {
			return state.list
		},

		/**
		 * [getById description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		getById(state) {
			return (id) => {
				return state.list.find(item => item.id===id)||{}
			}
		}
	},
	actions: {
		/*toggleSidebar({state, commit, dispatch}) {
			commit('setIsShowedSidebar', !state.isShowedSidebar)
		}*/
	},

}